export default "__VITE_ASSET__BokCy8ey__"